import React from 'react';
import { motion } from 'framer-motion';

export default function Card({ children, className = '', hover = false, variant = 'default', ...props }) {
  // Redesign: thin borders, tactile surfaces, 18-28px corners
  const baseClasses = variant === 'pine' 
    ? '!bg-pine !text-paper !border-transparent rounded-3xl shadow-sm transition-all duration-300'
    : 'bg-white border border-pine/10 rounded-3xl shadow-sm transition-all duration-300';
    
  const hoverClasses = variant === 'pine'
    ? (hover ? 'hover:shadow-md' : '')
    : (hover ? 'hover:shadow-md hover:border-pine/20' : '');

  return (
    <motion.div
      className={`${baseClasses} ${hoverClasses} ${className}`}
      {...props}
    >
      {children}
    </motion.div>
  );
}